import { render, staticRenderFns } from "./Consultation.vue?vue&type=template&id=20f6f9f8&scoped=true&"
import script from "./Consultation.vue?vue&type=script&lang=js&"
export * from "./Consultation.vue?vue&type=script&lang=js&"
import style0 from "./Consultation.vue?vue&type=style&index=0&id=20f6f9f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6f9f8",
  null
  
)

export default component.exports